import { resolveEnvironmentName } from './environment'

const BRWFM_REDIRECT_URLS: Record<string, string> = {
  production: 'https://app.dashboardinsights.com/wfm-client-signup/importData',
  prod: 'https://app.dashboardinsights.com/wfm-client-signup/importData',
  portal: 'https://portal.dashboardinsights.com/wfm-client-signup/importData',
  staging: 'https://staging.dashboardinsights.com/wfm-client-signup/importData',
  devtest: 'https://dev.dashboardinsights.com/wfm-client-signup/importData',
  dev: 'https://dev.dashboardinsights.com/wfm-client-signup/importData',
}

export function getBrwfmRedirectUrl(envName = resolveEnvironmentName()): string {
  return BRWFM_REDIRECT_URLS[envName] ?? 'https://dev.dashboardinsights.com/wfm-client-signup/importData'
}

export function constructWorkflowMaxAuthUrl(redirectUrl = getBrwfmRedirectUrl()) {
  const wfmClientId = (import.meta.env['VITE_WORKFLOWMAX_CLIENT_ID'] as string | undefined) || ''
  if (!wfmClientId || !redirectUrl) return ''
  return `https://oauth.workflowmax2.com/oauth/authorize?response_type=code&client_id=${wfmClientId}&redirect_uri=${encodeURIComponent(redirectUrl)}&scope=openid%20profile%20email%20workflowmax%20offline_access`
}
